var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Box, Button, CircularProgress, Typography, Alert } from "@mui/material";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Dialog, IconButton, PageLimit, SelectElection, theme } from "@sequentech/ui-essentials";
import { stringToHtml, translateFromPresentation, EVotingStatus, isUndefined, EEarlyVotingPolicy, EResultsWebsiteStatus, parseResultsWebsitePolicy, formatVotingPortalDateTime, ESupportMaterialsPolicy, getEffectiveSupportMaterialsPolicy, } from "@sequentech/ui-core";
import { AuthContext } from "../providers/AuthContextProvider";
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";
import { styled } from "@mui/material/styles";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { selectBallotStyleByElectionId, selectBallotStyleElectionIds, selectFirstBallotStyle, setBallotStyle, } from "../store/ballotStyles/ballotStylesSlice";
import { resetBallotSelection } from "../store/ballotSelections/ballotSelectionsSlice";
import { selectElectionById, setElection, selectElectionIds } from "../store/elections/electionsSlice";
import { addCastVotes, CastVoteStatus, selectCastVotesByElectionId, } from "../store/castVotes/castVotesSlice";
import { Link as RouterLink, useLocation, useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@apollo/client/react";
import { GET_BALLOT_STYLES } from "../queries/GetBallotStyles";
import { GET_ELECTIONS } from "../queries/GetElections";
import { ELECTIONS_LIST } from "../fixtures/election";
import { SettingsContext } from "../providers/SettingsContextProvider";
import { GET_ELECTION_EVENT } from "../queries/GetElectionEvent";
import { GET_CAST_VOTES } from "../queries/GetCastVotes";
import { ElectionScreenErrorType, ElectionScreenMsgType, VotingPortalError, VotingPortalErrorType, } from "../services/VotingPortalError";
import { selectElectionEventById, setElectionEvent, } from "../store/electionEvents/electionEventsSlice";
import Stepper from "../components/Stepper";
import { clearIsVoted, isAcclaimedElectionCompleted, selectBypassChooser, setBypassChooser, } from "../store/extra/extraSlice";
import { updateBallotStyleAndSelection } from "../services/BallotStyles";
import { BallotStyleConfigurationError } from "../services/BallotStyles";
import { GET_SUPPORT_MATERIALS } from "../queries/GetSupportMaterials";
import { GET_SUPPORT_MATERIALS_ACKNOWLEDGMENT } from "../queries/GetSupportMaterialsAcknowledgment";
import { setSupportMaterial } from "../store/supportMaterials/supportMaterialsSlice";
import { useElectionClassName } from "../hooks/useElectionClassName";
var StyledTitle = styled(Typography)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: 25.5px;\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n    font-size: 24px;\n    font-weight: 500;\n    line-height: 27px;\n    margin-top: 20px;\n    margin-bottom: 16px;\n"], ["\n    margin-top: 25.5px;\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n    font-size: 24px;\n    font-weight: 500;\n    line-height: 27px;\n    margin-top: 20px;\n    margin-bottom: 16px;\n"])));
var ElectionContainer = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: 30px;\n    margin-bottom: 30px;\n"], ["\n    display: flex;\n    flex-direction: column;\n    gap: 30px;\n    margin-bottom: 30px;\n"])));
var MaterialsGateLink = styled(RouterLink)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    color: inherit;\n    font-weight: 500;\n    text-decoration: underline;\n"], ["\n    color: inherit;\n    font-weight: 500;\n    text-decoration: underline;\n"])));
var TitleSection = styled(Box)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    gap: 32px;\n    min-height: 100px;\n\n    @media (max-width: ", "px) {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 16px;\n        min-height: unset;\n        padding: 24px 0;\n    }\n"], ["\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    gap: 32px;\n    min-height: 100px;\n\n    @media (max-width: ", "px) {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 16px;\n        min-height: unset;\n        padding: 24px 0;\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.values.sm;
});
var PageActions = styled(Box)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n    gap: 16px;\n\n    .election-event-results-button {\n        min-width: 150px;\n        padding: 10px 24px;\n        justify-content: center;\n        font-weight: 500;\n        line-height: 24px;\n        white-space: nowrap;\n    }\n\n    @media (max-width: ", "px) {\n        width: 100%;\n\n        > .MuiButton-root {\n            flex: 1;\n        }\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n    gap: 16px;\n\n    .election-event-results-button {\n        min-width: 150px;\n        padding: 10px 24px;\n        justify-content: center;\n        font-weight: 500;\n        line-height: 24px;\n        white-space: nowrap;\n    }\n\n    @media (max-width: ", "px) {\n        width: 100%;\n\n        > .MuiButton-root {\n            flex: 1;\n        }\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.values.sm;
});
var isElectionEventOnlineVotingOpen = function (electionEvent) {
    var _a, _b;
    return (((_b = (_a = electionEvent === null || electionEvent === void 0 ? void 0 : electionEvent.status) === null || _a === void 0 ? void 0 : _a.voting_status) !== null && _b !== void 0 ? _b : EVotingStatus.CLOSED) === EVotingStatus.OPEN);
};
var isElectionEventKioskOpen = function (electionEvent) {
    var _a, _b;
    return (((_b = (_a = electionEvent === null || electionEvent === void 0 ? void 0 : electionEvent.status) === null || _a === void 0 ? void 0 : _a.kiosk_voting_status) !== null && _b !== void 0 ? _b : EVotingStatus.CLOSED) === EVotingStatus.OPEN);
};
var isElectionEventEarlyVotingOpen = function (electionEvent) {
    var _a, _b;
    return (((_b = (_a = electionEvent === null || electionEvent === void 0 ? void 0 : electionEvent.status) === null || _a === void 0 ? void 0 : _a.early_voting_status) !== null && _b !== void 0 ? _b : EVotingStatus.CLOSED) === EVotingStatus.OPEN);
};
var isResultsWebsiteEnabled = function (electionEvent) {
    var _a, _b;
    return (((_b = parseResultsWebsitePolicy((_a = electionEvent === null || electionEvent === void 0 ? void 0 : electionEvent.presentation) === null || _a === void 0 ? void 0 : _a.results_website)) === null || _b === void 0 ? void 0 : _b.status) ===
        EResultsWebsiteStatus.ENABLED);
};
var isElectionEventVotingClosed = function (electionEvent) {
    return (!isElectionEventOnlineVotingOpen(electionEvent) &&
        !isElectionEventKioskOpen(electionEvent) &&
        !isElectionEventEarlyVotingOpen(electionEvent));
};
var ElectionWrapper = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var electionId = _a.electionId, bypassChooser = _a.bypassChooser, canVoteTest = _a.canVoteTest, materialsGate = _a.materialsGate;
    var navigate = useNavigate();
    var location = useLocation();
    var i18n = useTranslation().i18n;
    var _h = useParams(), tenantId = _h.tenantId, eventId = _h.eventId;
    var electionEvent = useAppSelector(selectElectionEventById(eventId));
    var election = useAppSelector(selectElectionById(electionId));
    var ballotStyle = useAppSelector(selectBallotStyleByElectionId(electionId));
    var castVotes = useAppSelector(selectCastVotesByElectionId(String(electionId)));
    var isAcclaimedCompleted = useAppSelector(isAcclaimedElectionCompleted(electionId));
    var _j = useState(false), visitedBypassChooser = _j[0], setVisitedBypassChooser = _j[1];
    var authContext = useContext(AuthContext);
    var globalSettings = useContext(SettingsContext).globalSettings;
    var isKiosk = authContext.isKiosk();
    var getElectionClassName = useElectionClassName()[0];
    if (!election) {
        throw new VotingPortalError(VotingPortalErrorType.INTERNAL_ERROR);
    }
    var defaultLanguageCode = (_d = (_c = (_b = election.presentation) === null || _b === void 0 ? void 0 : _b.language_conf) === null || _c === void 0 ? void 0 : _c.default_language_code) !== null && _d !== void 0 ? _d : (_f = (_e = electionEvent === null || electionEvent === void 0 ? void 0 : electionEvent.presentation) === null || _e === void 0 ? void 0 : _e.language_conf) === null || _f === void 0 ? void 0 : _f.default_language_code;
    var electionClassName = getElectionClassName(election);
    var electionStatus = election === null || election === void 0 ? void 0 : election.status;
    var isVotingOpen = function () {
        var isOnlineVotingOpen = (electionStatus === null || electionStatus === void 0 ? void 0 : electionStatus.voting_status) === EVotingStatus.OPEN;
        if (isKiosk) {
            return isKioskOpen() && isElectionEventKioskOpen(electionEvent);
        }
        else {
            return ((isOnlineVotingOpen && isElectionEventOnlineVotingOpen(electionEvent)) ||
                (isEarlyVotingOpen() && isElectionEventEarlyVotingOpen(electionEvent)));
        }
    };
    var isKioskOpen = function () {
        return (electionStatus === null || electionStatus === void 0 ? void 0 : electionStatus.kiosk_voting_status) === EVotingStatus.OPEN;
    };
    var isEarlyVotingPolicyEnabled = function () {
        var _a;
        var area_presentation = (_a = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml) === null || _a === void 0 ? void 0 : _a.area_presentation;
        return area_presentation.allow_early_voting === EEarlyVotingPolicy.ALLOW_EARLY_VOTING;
    };
    var isEarlyVotingOpen = function () {
        var isOpen = (electionStatus === null || electionStatus === void 0 ? void 0 : electionStatus.early_voting_status) === EVotingStatus.OPEN;
        return isEarlyVotingPolicyEnabled() && isOpen;
    };
    var isVotingStarted = function () {
        if (isKiosk) {
            return (electionStatus === null || electionStatus === void 0 ? void 0 : electionStatus.kiosk_voting_status) !== EVotingStatus.NOT_STARTED;
        }
        else {
            return ((electionStatus === null || electionStatus === void 0 ? void 0 : electionStatus.voting_status) !== EVotingStatus.NOT_STARTED ||
                (isEarlyVotingPolicyEnabled() &&
                    (electionStatus === null || electionStatus === void 0 ? void 0 : electionStatus.early_voting_status) !== EVotingStatus.NOT_STARTED));
        }
    };
    var isPreview = sessionStorage.getItem("isDemo") === "true";
    var canVote = function () {
        var _a, _b;
        if (materialsGate) {
            return false;
        }
        if (!canVoteTest && !((_a = election.name) === null || _a === void 0 ? void 0 : _a.includes("TEST"))) {
            return false;
        }
        if (isAcclaimedCompleted) {
            return false;
        }
        if ((ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml.num_allowed_revotes) === 0) {
            return true;
        }
        return (isPreview ||
            (castVotes.length < ((_b = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml.num_allowed_revotes) !== null && _b !== void 0 ? _b : 1) &&
                isVotingOpen()));
    };
    var onClickToVote = function () {
        if (!canVote() || (!isPreview && !isVotingOpen())) {
            console.log("cannot vote");
            return;
        }
        navigate("/tenant/".concat(tenantId, "/event/").concat(eventId, "/election/").concat(electionId, "/start").concat(location.search));
    };
    var handleClickBallotLocator = function () {
        navigate("../election/".concat(electionId, "/ballot-locator").concat(location.search));
    };
    var resultsUrl = globalSettings.RESULTS_PORTAL_URL &&
        eventId &&
        !isVotingOpen() &&
        isResultsWebsiteEnabled(electionEvent)
        ? "".concat(globalSettings.RESULTS_PORTAL_URL.replace(/\/+$/, ""), "/").concat(eventId, "/elections/").concat(electionId)
        : undefined;
    useEffect(function () {
        if (visitedBypassChooser) {
            console.log("visitedBypassChooser");
            return;
        }
        if (bypassChooser && ballotStyle) {
            console.log("setVisitedBypassChooser");
            setVisitedBypassChooser(true);
            onClickToVote();
        }
    }, [bypassChooser, visitedBypassChooser, setVisitedBypassChooser, ballotStyle]);
    return (_jsx(SelectElection, { isActive: canVote(), isOpen: isVotingOpen(), title: translateFromPresentation(election, "name", i18n.language, {
            defaultLanguageCode: defaultLanguageCode,
        }) || "-", hasVoted: castVotes.length > 0, onClickToVote: canVote() ? onClickToVote : undefined, onClickBallotLocator: handleClickBallotLocator, resultsUrl: resultsUrl, electionDates: (_g = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml) === null || _g === void 0 ? void 0 : _g.election_dates, isStarted: isVotingStarted(), className: electionClassName, formatDateTime: function (input) {
            return formatVotingPortalDateTime(input, electionEvent, i18n.resolvedLanguage || i18n.language);
        } }));
};
var fakeUpdateBallotStyleAndSelection = function (dispatch) {
    for (var _i = 0, ELECTIONS_LIST_1 = ELECTIONS_LIST; _i < ELECTIONS_LIST_1.length; _i++) {
        var election = ELECTIONS_LIST_1[_i];
        try {
            var formattedBallotStyle = {
                id: election.id,
                election_id: election.id,
                election_event_id: election.id,
                tenant_id: election.id,
                ballot_eml: election,
                ballot_signature: null,
                created_at: "",
                area_id: election.id,
                annotations: null,
                labels: null,
                last_updated_at: "",
            };
            dispatch(setElection(__assign(__assign({}, election), { image_document_id: "" })));
            dispatch(setBallotStyle(formattedBallotStyle));
            dispatch(clearIsVoted());
            dispatch(resetBallotSelection({
                ballotStyle: formattedBallotStyle,
            }));
        }
        catch (error) {
            console.log("Error loading fake EML: ".concat(error), election);
            throw new VotingPortalError(VotingPortalErrorType.INTERNAL_ERROR);
        }
    }
};
var ElectionSelectionScreen = function () {
    var _a, _b, _c, _d, _e, _f;
    var _g = useTranslation(), t = _g.t, i18n = _g.i18n;
    var navigate = useNavigate();
    var location = useLocation();
    var globalSettings = useContext(SettingsContext).globalSettings;
    var _h = useParams(), eventId = _h.eventId, tenantId = _h.tenantId;
    var electionEvent = useAppSelector(selectElectionEventById(eventId));
    var eventDefaultLanguageCode = (_b = (_a = electionEvent === null || electionEvent === void 0 ? void 0 : electionEvent.presentation) === null || _a === void 0 ? void 0 : _a.language_conf) === null || _b === void 0 ? void 0 : _b.default_language_code;
    var oneBallotStyle = useAppSelector(selectFirstBallotStyle);
    var ballotStyleElectionIds = useAppSelector(selectBallotStyleElectionIds);
    var electionIds = useAppSelector(selectElectionIds);
    var dispatch = useAppDispatch();
    var _j = useState(true), canVoteTest = _j[0], setCanVoteTest = _j[1];
    var _k = useState(null), testElectionId = _k[0], setTestElectionId = _k[1];
    var castVotesTestElection = useAppSelector(selectCastVotesByElectionId(String(testElectionId || tenantId)));
    var _l = useState(false), openChooserHelp = _l[0], setOpenChooserHelp = _l[1];
    // Derived directly from the published ballot style snapshot (not the live
    // election event) on every render, so a policy change only takes effect
    // after the next publication, and the correct value is available as soon
    // as oneBallotStyle is - no extra render cycle lag through a state+effect
    // pair that would otherwise let a stale "Off" default flash through
    // (visible in particular on a hard page refresh).
    var materialsPolicy = getEffectiveSupportMaterialsPolicy((_c = oneBallotStyle === null || oneBallotStyle === void 0 ? void 0 : oneBallotStyle.ballot_eml.election_event_presentation) === null || _c === void 0 ? void 0 : _c.materials);
    var isMaterialsVisible = materialsPolicy !== ESupportMaterialsPolicy.OFF;
    var isMaterialsMandatory = materialsPolicy === ESupportMaterialsPolicy.MANDATORY_FOR_VOTING;
    var bypassChooser = useAppSelector(selectBypassChooser());
    var _m = useState(), errorMsg = _m[0], setErrorMsg = _m[1];
    var _o = useState(undefined), errorMsgElectionIds = _o[0], setErrorMsgElectionIds = _o[1];
    var _p = useState(undefined), ballotStyleConfigurationError = _p[0], setBallotStyleConfigurationError = _p[1];
    var _q = useState(), alertMsg = _q[0], setAlertMsg = _q[1];
    var eventResultsUrl = globalSettings.RESULTS_PORTAL_URL &&
        eventId &&
        isResultsWebsiteEnabled(electionEvent) &&
        isElectionEventVotingClosed(electionEvent)
        ? "".concat(globalSettings.RESULTS_PORTAL_URL.replace(/\/+$/, ""), "/").concat(eventId)
        : undefined;
    var _r = useQuery(GET_BALLOT_STYLES, {
        skip: globalSettings.DISABLE_AUTH, // Skip query if in demo mode
    }), errorBallotStyles = _r.error, dataBallotStyles = _r.data, loadingBallotStyles = _r.loading;
    var _s = useQuery(GET_ELECTIONS, {
        variables: {
            electionIds: ballotStyleElectionIds,
        },
        skip: globalSettings.DISABLE_AUTH, // Skip query if in demo mode
    }), errorElections = _s.error, dataElections = _s.data, loadingElections = _s.loading;
    var _t = useQuery(GET_ELECTION_EVENT, {
        variables: {
            electionEventId: eventId,
            tenantId: tenantId,
        },
        skip: globalSettings.DISABLE_AUTH, // Skip query if in demo mode
    }), errorElectionEvent = _t.error, dataElectionEvent = _t.data, loadingElectionEvent = _t.loading;
    // Materials
    var _u = useQuery(GET_SUPPORT_MATERIALS, {
        variables: {
            electionEventId: eventId || "",
            tenantId: tenantId || "",
        },
        skip: globalSettings.DISABLE_AUTH || !isMaterialsVisible, // Skip query if in demo mode
    }), dataMaterials = _u.data, errorMaterials = _u.error, loadingMaterials = _u.loading;
    var _v = useQuery(GET_SUPPORT_MATERIALS_ACKNOWLEDGMENT, {
        variables: {
            electionEventId: eventId || "",
        },
        // Support Materials writes the acknowledgment straight into the Apollo
        // cache on Continue (see SupportMaterialsScreen), so the default
        // cache-first policy already reflects it instantly on return here
        // instead of re-gating the Ballot list behind a fresh network round trip.
        skip: globalSettings.DISABLE_AUTH || !isMaterialsMandatory,
    }), dataMaterialsAcknowledgment = _v.data, errorMaterialsAcknowledgment = _v.error, loadingMaterialsAcknowledgment = _v.loading;
    // Whether we have a definitive answer yet. On a fresh page load the Apollo
    // cache starts empty, so these queries are genuinely loading for a moment -
    // default to "not yet known" rather than "not acknowledged" so voting
    // stays blocked (safe) without flashing the gate banner (misleading) for a
    // voter who has, in fact, already acknowledged.
    var hasAcknowledgmentLoaded = !isMaterialsMandatory ||
        (dataMaterialsAcknowledgment !== undefined && dataMaterials !== undefined);
    var acknowledgedDocumentIds = new Set((_e = (_d = dataMaterialsAcknowledgment === null || dataMaterialsAcknowledgment === void 0 ? void 0 : dataMaterialsAcknowledgment.get_support_materials_acknowledgment) === null || _d === void 0 ? void 0 : _d.document_ids) !== null && _e !== void 0 ? _e : []);
    // Acknowledging is per-document, so a material published after the
    // voter's last acknowledgment must gate voting again - checking the
    // acknowledged count alone would let that new material slip through.
    var hasAcknowledgedSupportMaterials = !isMaterialsMandatory ||
        ((_f = dataMaterials === null || dataMaterials === void 0 ? void 0 : dataMaterials.sequent_backend_support_material.every(function (material) { return !material.document_id || acknowledgedDocumentIds.has(material.document_id); })) !== null && _f !== void 0 ? _f : false);
    var _w = useQuery(GET_CAST_VOTES, {
        skip: globalSettings.DISABLE_AUTH,
    }), castVotes = _w.data, errorCastVote = _w.error, startCastVotePolling = _w.startPolling, stopCastVotePolling = _w.stopPolling;
    var materialsPath = "/tenant/".concat(tenantId, "/event/").concat(eventId, "/materials").concat(location.search);
    var materialsTitle = (electionEvent &&
        translateFromPresentation(electionEvent, "materialsTitle", i18n.language, {
            defaultLanguageCode: eventDefaultLanguageCode,
        })) ||
        t("materials.common.label");
    var handleNavigateMaterials = function () {
        navigate(materialsPath);
    };
    var hasNoElections = !loadingElections && (dataElections === null || dataElections === void 0 ? void 0 : dataElections.sequent_backend_election.length) === 0;
    var isPublished = useMemo(function () { var _a; return !!((_a = dataElectionEvent === null || dataElectionEvent === void 0 ? void 0 : dataElectionEvent.sequent_backend_election_event[0].status) === null || _a === void 0 ? void 0 : _a.is_published); }, [dataElectionEvent === null || dataElectionEvent === void 0 ? void 0 : dataElectionEvent.sequent_backend_election_event]);
    useEffect(function () {
        if (!dataMaterials || globalSettings.DISABLE_AUTH || !isMaterialsVisible) {
            return;
        }
        for (var _i = 0, _a = dataMaterials.sequent_backend_support_material; _i < _a.length; _i++) {
            var material = _a[_i];
            dispatch(setSupportMaterial(material));
        }
    }, [dataMaterials, globalSettings.DISABLE_AUTH, isMaterialsVisible]);
    // Errors handling
    useEffect(function () {
        if (globalSettings.DISABLE_AUTH) {
            return;
        }
        if (errorElections || errorElectionEvent || errorBallotStyles || errorCastVote) {
            if (errorBallotStyles === null || errorBallotStyles === void 0 ? void 0 : errorBallotStyles.message.includes("x-hasura-area-id")) {
                setErrorMsg(ElectionScreenErrorType.NO_AREA);
            }
            else if ((errorElections === null || errorElections === void 0 ? void 0 : errorElections.networkError) ||
                (errorElectionEvent === null || errorElectionEvent === void 0 ? void 0 : errorElectionEvent.networkError) ||
                (errorBallotStyles === null || errorBallotStyles === void 0 ? void 0 : errorBallotStyles.networkError) ||
                (errorCastVote === null || errorCastVote === void 0 ? void 0 : errorCastVote.networkError)) {
                setErrorMsg(ElectionScreenErrorType.NETWORK);
            }
            else {
                setErrorMsg(ElectionScreenErrorType.FETCH_DATA);
            }
        }
        else if ((dataElectionEvent === null || dataElectionEvent === void 0 ? void 0 : dataElectionEvent.sequent_backend_election_event.length) === 0) {
            setErrorMsg(ElectionScreenErrorType.NO_ELECTION_EVENT);
        }
        else if (!isPublished) {
            setAlertMsg(ElectionScreenMsgType.NOT_PUBLISHED);
        }
        else if (hasNoElections) {
            if (electionIds.length > 0) {
                setErrorMsg(ElectionScreenErrorType.OBTAINING_ELECTION);
                setErrorMsgElectionIds(JSON.stringify(electionIds));
            }
            else {
                setAlertMsg(ElectionScreenMsgType.NO_ELECTIONS);
            }
        }
        else {
            setAlertMsg(undefined);
            setErrorMsg(undefined);
        }
    }, [
        errorBallotStyles,
        errorCastVote,
        errorElectionEvent,
        errorElections,
        isPublished,
        hasNoElections,
        dataElectionEvent,
        globalSettings.DISABLE_AUTH,
    ]);
    useEffect(function () {
        if (dataBallotStyles && dataBallotStyles.sequent_backend_ballot_style.length > 0) {
            try {
                updateBallotStyleAndSelection(dataBallotStyles, dispatch);
                setBallotStyleConfigurationError(undefined);
            }
            catch (error) {
                if (error instanceof BallotStyleConfigurationError) {
                    setBallotStyleConfigurationError({
                        translationKey: error.translationKey,
                        translationParams: error.translationParams,
                    });
                    setErrorMsg(undefined);
                }
                else {
                    setBallotStyleConfigurationError(undefined);
                    setErrorMsg(ElectionScreenErrorType.BALLOT_STYLES_EML);
                }
            }
        }
        else if (globalSettings.DISABLE_AUTH) {
            //fakeUpdateBallotStyleAndSelection(dispatch)
        }
    }, [globalSettings.DISABLE_AUTH, dataBallotStyles, dispatch]);
    useEffect(function () {
        var _a, _b, _c;
        if (dataElections && dataElections.sequent_backend_election.length > 0) {
            for (var _i = 0, _d = dataElections.sequent_backend_election; _i < _d.length; _i++) {
                var election = _d[_i];
                dispatch(setElection(__assign(__assign({}, election), { image_document_id: "", contests: [], description: (_a = election.description) !== null && _a !== void 0 ? _a : undefined, alias: election.presentation
                        ? translateFromPresentation(election.presentation, "alias", i18n.language, {
                            defaultLanguageCode: (_c = (_b = election.presentation.language_conf) === null || _b === void 0 ? void 0 : _b.default_language_code) !== null && _c !== void 0 ? _c : eventDefaultLanguageCode,
                        })
                        : undefined })));
            }
            var foundTestElection = dataElections.sequent_backend_election.find(function (election) {
                var _a, _b, _c;
                var name = election.presentation
                    ? translateFromPresentation(election.presentation, "name", i18n.language, {
                        defaultLanguageCode: (_b = (_a = election.presentation.language_conf) === null || _a === void 0 ? void 0 : _a.default_language_code) !== null && _b !== void 0 ? _b : eventDefaultLanguageCode,
                    })
                    : undefined;
                return (_c = name === null || name === void 0 ? void 0 : name.includes("TEST")) !== null && _c !== void 0 ? _c : false;
            });
            if (foundTestElection) {
                setCanVoteTest(false);
            }
            setTestElectionId((foundTestElection === null || foundTestElection === void 0 ? void 0 : foundTestElection.id) || null);
        }
    }, [dataElections, dispatch, eventDefaultLanguageCode, i18n.language]);
    useEffect(function () {
        if (!testElectionId) {
            return;
        }
        setCanVoteTest(castVotesTestElection.length > 0);
    }, [castVotesTestElection, testElectionId, setCanVoteTest]);
    useEffect(function () {
        var _a;
        var record = (_a = dataElectionEvent === null || dataElectionEvent === void 0 ? void 0 : dataElectionEvent.sequent_backend_election_event) === null || _a === void 0 ? void 0 : _a[0];
        if (record) {
            dispatch(setElectionEvent(record));
        }
    }, [dataElectionEvent, dispatch]);
    useEffect(function () {
        if (castVotes === null || castVotes === void 0 ? void 0 : castVotes.sequent_backend_cast_vote) {
            var castVoteList = castVotes.sequent_backend_cast_vote;
            dispatch(addCastVotes(castVoteList));
            var hasUnresolvedCastVotes = castVoteList.some(function (castVote) { return castVote.status === CastVoteStatus.IN_PROGRESS; });
            if (hasUnresolvedCastVotes) {
                startCastVotePolling(globalSettings.QUERY_POLL_INTERVAL_MS);
            }
            else {
                stopCastVotePolling();
            }
        }
    }, [
        castVotes,
        dispatch,
        globalSettings.QUERY_POLL_INTERVAL_MS,
        startCastVotePolling,
        stopCastVotePolling,
    ]);
    useEffect(function () {
        var _a, _b;
        var skipPolicy = (_b = (_a = oneBallotStyle === null || oneBallotStyle === void 0 ? void 0 : oneBallotStyle.ballot_eml.election_event_presentation) === null || _a === void 0 ? void 0 : _a.skip_election_list) !== null && _b !== void 0 ? _b : false;
        console.log("skipPolicy", skipPolicy);
        var newBypassChooser = skipPolicy &&
            1 === electionIds.length &&
            !errorCastVote &&
            !isUndefined(castVotes) &&
            !!electionEvent &&
            !!dataElections;
        if (newBypassChooser && !bypassChooser) {
            console.log("new baypass chooser", newBypassChooser);
            dispatch(setBypassChooser(newBypassChooser));
        }
    }, [
        castVotes,
        electionIds,
        errorCastVote,
        castVotes,
        electionEvent,
        dataElections,
        oneBallotStyle,
    ]);
    var warningMsg = errorMsg
        ? t("electionSelectionScreen.errors.".concat(errorMsg), {
            electionIds: errorMsgElectionIds,
        })
        : ballotStyleConfigurationError
            ? t(ballotStyleConfigurationError.translationKey, ballotStyleConfigurationError.translationParams)
            : alertMsg
                ? t("electionSelectionScreen.alerts.".concat(alertMsg))
                : undefined;
    // Block voting until we positively know the voter has acknowledged.
    var materialsGate = isMaterialsMandatory && !(hasAcknowledgmentLoaded && hasAcknowledgedSupportMaterials);
    // Only show the instruction banner once acknowledgment status is
    // positively known to be missing - never while it's still loading, so a
    // page refresh doesn't flash it before the "already acknowledged" result
    // arrives.
    var showMaterialsGateBanner = isMaterialsMandatory && hasAcknowledgmentLoaded && !hasAcknowledgedSupportMaterials;
    if (loadingElectionEvent || loadingElections || loadingBallotStyles)
        return (_jsx(CircularProgress, { className: "election-selection-progress", "aria-label": t("a11y.loading") }));
    return (_jsxs(PageLimit, { maxWidth: "lg", className: "election-selection-screen screen", children: [_jsx(Box, { className: "stepper-box", marginTop: "48px", children: _jsx(Stepper, { selected: 0 }) }), _jsxs(TitleSection, { className: "title-section", children: [_jsxs(Box, { sx: { flex: 1, minWidth: 0 }, className: "election-selection-heading", children: [_jsxs(StyledTitle, { className: "screen-title", variant: "h1", children: [_jsx(Box, { className: "screen-title-text", children: t("electionSelectionScreen.title") }), _jsx(IconButton, { buttonClassName: "screen-help-button", icon: faCircleQuestion, sx: { fontSize: "unset", lineHeight: "unset", paddingBottom: "2px" }, fontSize: "16px", onClick: function () { return setOpenChooserHelp(true); }, ariaLabel: t("a11y.helpAbout", {
                                            topic: t("electionSelectionScreen.chooserHelpDialog.title"),
                                        }) }), _jsx(Dialog, { className: "screen-help-dialog election-selection-help-dialog", handleClose: function () { return setOpenChooserHelp(false); }, open: openChooserHelp, title: t("electionSelectionScreen.chooserHelpDialog.title"), ok: t("electionSelectionScreen.chooserHelpDialog.ok"), variant: "info", children: stringToHtml(t("electionSelectionScreen.chooserHelpDialog.content")) })] }), warningMsg ? (_jsx(Alert, { className: "election-selection-warning", severity: "warning", children: warningMsg })) : (_jsx(Typography, { className: "screen-description", variant: "body1", component: "div", sx: { color: theme.palette.customGrey.contrastText }, children: stringToHtml(t("electionSelectionScreen.description")) }))] }), _jsxs(PageActions, { className: "election-event-actions", children: [eventResultsUrl ? (_jsx(Button, { className: "results-button election-event-results-button", variant: "secondary", component: "a", href: eventResultsUrl, target: "_blank", rel: "noreferrer", children: t("electionSelectionScreen.resultsButton") })) : null, isMaterialsVisible && electionEvent ? (_jsx(Button, { className: "support-materials-button", onClick: handleNavigateMaterials, children: materialsTitle })) : null] })] }), showMaterialsGateBanner ? (_jsx(Alert, { severity: "warning", className: "materials-gate-banner", sx: { marginBottom: "16px" }, children: _jsx(Trans, { i18nKey: "electionSelectionScreen.materialsGate.instructions", values: { materialsTitle: materialsTitle }, components: {
                        MaterialsLink: (_jsx(MaterialsGateLink, { className: "materials-gate-link", to: materialsPath })),
                    } }) })) : null, _jsx(ElectionContainer, { className: "elections-list", role: hasNoElections ? undefined : "list", children: !hasNoElections ? (electionIds.map(function (electionId) { return (_jsx(ElectionWrapper, { electionId: electionId, bypassChooser: bypassChooser, canVoteTest: canVoteTest, materialsGate: materialsGate }, electionId)); })) : (_jsx(Box, { className: "elections-empty", sx: { margin: "auto" }, children: _jsx(Typography, { className: "election-selection-empty", children: t("electionSelectionScreen.noResults") }) })) })] }));
};
export default ElectionSelectionScreen;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
